// import React from 'react'

// const Scorce = () => {
//   return (
//     <div>Scorce</div>
//   )
// }

// export default Scorce



import React, { useState, useEffect } from 'react';
import axios from 'axios';

const Scorce = () => {
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Fetch all quiz results from the backend
    useEffect(() => {
        const fetchResults = async () => {
            try {
                const response = await axios.get('https://a4f87ed0aaa59fecf8c667409b3eac16.serveo.net/api/solution');
                setResults(response.data);
                setLoading(false);
            } catch (err) {
                setError(err.response ? err.response.data.message : err.message);
                setLoading(false);
            }
        };

        fetchResults();
    }, []);

    if (loading) {
        return <p>Loading...</p>;
    }

    if (error) {
        return <p>Error: {error}</p>;
    }

    return (
        <div>
            <h2>Quiz Results</h2>
            <table border="1" cellPadding="10" cellSpacing="0">
                <thead>
                    <tr>
                        <th>Serial No</th>
                        <th>Name</th>
                        <th>Department</th>
                        <th>Correct Answers</th>
                        <th>Percentage</th>
                    </tr>
                </thead>
                <tbody>
                    {results.map((result, index) => (
                        <tr key={result._id}>
                            <td>{index + 1}</td>
                            <td>{result.name}</td>
                            <td>{result.department}</td>
                            <td>{result.correctAnswers}</td>
                            <td>{result.percentage}%</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default Scorce;
